import { formatCurrency } from "../../../../helpers";
import styles from "./AiUsageMeter.module.scss";

const formatNaira = (value) =>
  formatCurrency({ value: Number(value || 0), currencyCode: "NGN" });

// Daily spend against the company's cap. Every figure — the cap, the percent
// and both flags — comes off the `usage` block on the last reply; nothing here
// is recomputed or compared against a hardcoded threshold.
const AiUsageMeter = ({ usage }) => {
  const dailyLimit = Number(usage?.daily_limit || 0);

  // No usage yet (no reply this session) or an uncapped company: no meter
  if (!usage || !dailyLimit) return null;

  const percentUsed = Number(usage.percent_used || 0);
  const isBlocked = usage.limit_reached === true || usage.can_use_ai === false;
  const isWarning = !isBlocked && usage.near_limit === true;
  const state = isBlocked ? "blocked" : isWarning ? "warning" : "normal";

  return (
    <div
      className={`${styles.aiUsage} ${styles[`aiUsage--${state}`]}`}
      title={`${formatNaira(usage.spent_today)} of ${formatNaira(
        usage.daily_limit,
      )} of today's AI limit used`}
    >
      <div className={styles.aiUsage__bar}>
        <span
          style={{ width: `${Math.min(100, Math.max(0, percentUsed))}%` }}
        />
      </div>
      <span className={styles.aiUsage__label}>
        {formatNaira(usage.spent_today)} of {formatNaira(usage.daily_limit)}{" "}
        used today
      </span>
    </div>
  );
};

export default AiUsageMeter;
